// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    // Fixa a chave do localStorage em vez de deixar o supabase-js derivá-la do
    // hostname (`sb-<primeiro-rótulo>-auth-token`). O ChatContar desktop lê a
    // sessão daqui para baixar anexos (electron-chat/chatDownloader.cjs); se a
    // chave mudasse junto com o domínio do Supabase, ele pararia de arquivar os
    // anexos em silêncio, sem erro visível.
    storageKey: 'sb-ecoweb-auth-token',
  }
});